import React from 'react'
import Navbar from './Navbar'
import Home from './Home'

function Main() {
  return (
    <div>
        <Navbar/>
        <Home/>
    </div>
  )
}

export default Main